import { GeoJsonLayer } from "@deck.gl/layers";
import NordStreamImage from "../../icons/nord_stream_leak.png";

export function getNordStreamLayer(): GeoJsonLayer<any>[] {

  if (!window.location.search.includes('nord')) {
    return [];
  }

  return [new GeoJsonLayer({
    id: 'nord_stream',
    data: { type: "FeatureCollection", features: [{ type: "Feature", properties: { description: "Nord Stream 2 leak site" }, geometry: { type: "Point", coordinates: [15.410000, 54.876670] } }] },
    pickable: true,
    autoHighlight: true,
    pointType: 'icon',
    getIcon: () => ({ id: "NordStreamImage", url: NordStreamImage, width: 302, height: 274 }),
    iconSizeUnits: "meters",
    getIconSize: 5000,
    highlightColor: [100, 100, 100, 180],
    getIconColor: [0, 0, 0, 255],
    parameters: {
      depthTest: false
    },
  })];
}
